import { render, staticRenderFns } from "./returngood.vue?vue&type=template&id=25cac65f&scoped=true&"
import script from "./returngood.vue?vue&type=script&lang=js&"
export * from "./returngood.vue?vue&type=script&lang=js&"
import style0 from "./returngood.vue?vue&type=style&index=0&id=25cac65f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cac65f",
  null
  
)

export default component.exports